/* eslint-disable class-methods-use-this */
import http from './httpService';

// const { abp } = window;

class SessionService {
  async getCurrentLoginInformations() {
    const result = await http.get(
      'api/services/app/Session/GetCurrentLoginInformations',
      {
        // headers: {
        //   `${abp.multiTenancy.tenantIdCookieName}`: abp.multiTenancy.getTenantIdCookie(),
        // },
      }
    );
    return result.data;
  }

  async getTenantDisplayInfo() {
    const result = await http.get(
      'api/services/app/Session/GetTenantDisplayInfo'
    );
    return result.data.result;
  }

  async getTenantsForSelection() {
    const result = await http.get(
      'api/services/app/Session/GetTenantsForSelection'
    );
    return result.data.result;
  }

  async getOrganizationSettings() {
    const result = await http.get(
      'api/services/app/Session/GetOrganizationSettings'
    );
    return result.data.result;
  }

  async setProfileImage(input) {
    const result = await http.post(
      'api/services/app/Session/SetProfileImage',
      input
    );
    return result.data;
  }
}

export default SessionService = new SessionService();
